import { action, configure, decorate, observable, runInAction } from 'mobx';
import { RootStore } from './RootStore';

configure({ enforceActions: 'observed' });
const desktopBreakPoint = window.matchMedia
  ? window.matchMedia(`(min-width: ${process.env.REACT_APP_DESKTOP_BREAKPOINT as string})`)
  : null;

export class AppStore {
  rootStore: RootStore;
  isMobileMenuOpen: boolean;
  isMobileSearchOpen: boolean;
  isMobile: boolean | null;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.isMobile = desktopBreakPoint ? !desktopBreakPoint.matches : null;
    this.isMobileMenuOpen = false;
    this.isMobileSearchOpen = false;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  openMobileMenu() {
    this.isMobileMenuOpen = true;
  }

  closeMobileSearch() {
    this.isMobileSearchOpen = false;
  }

  openMobileSearch() {
    this.isMobileSearchOpen = true;
  }

  checkVewPort() {
    if (desktopBreakPoint) {
      desktopBreakPoint.addListener(mq => {
        runInAction(() => {
          this.isMobile = !mq.matches;
        });
      });
    }
  }
}

decorate(AppStore, {
  checkVewPort: action,
  closeMobileMenu: action.bound,
  closeMobileSearch: action.bound,
  isMobile: observable,
  isMobileMenuOpen: observable,
  isMobileSearchOpen: observable,
  openMobileMenu: action.bound,
  openMobileSearch: action.bound,
});
